module.exports = __webpack_public_path__ + "static/media/resume.7b5028b9.pdf";